import orderApi from '@/api/order';
import { loadEntity, loadPaginatedEntity } from '@/helpers/utility';

const state = {
    byId: {},
    currentPage: null,
    totalPages: null,
    currentPageIds: null,

    statuses: {
        pending: 'Pending',
        placed: 'Placed',
        received: 'Received',
        canceled: 'Canceled',
    },
};

const getters = {
    currentPageOrders(state) {
        if (state.currentPageIds)
            return state.currentPageIds.map(id => state.byId[id]);
    },
};

const actions = {
    async getPaginatedOrders(store, { page, vendor }) {
        let pagedOrders = await orderApi.paginatedList({ page, vendor });
        loadPaginatedEntity('orders', pagedOrders);
    },
    async getOrder(context, { id }) {
        let order = await orderApi.get(id);
        loadEntity({ order });
    },
    async updateOrder(context, { order }) {
        order = await orderApi.update(order);
        loadEntity({ order });
    },
};

const mutations = {
    LOAD_ENTITIES(state, { orders, meta }) {
        if (orders)
            Object.values(orders).forEach(order => Vue.set(state.byId, order.id, order));

        if (meta && meta.type === 'orders' && meta.paginated) {
            state.currentPage = meta.currentPage;
            state.totalPages = meta.totalPages;
            state.currentPageIds = meta.ids;
        }
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
